var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icons-list"},[_vm._l((_vm.icons),function(ref,keyIcons){
var icon = ref.icon;
var title = ref.title;
return [_c('div',{key:keyIcons,staticClass:"icons-list-item"},[_c('img',{staticClass:"d-block mx-auto icons-list-item-img",attrs:{"src":icon + '?resize=1&h=35',"height":"35px","width":"auto"}}),_c('div',{staticClass:"text-center accent--text mt-2"},[_c('div',{domProps:{"innerHTML":_vm._s(title)}})])])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }